import React, { useRef, useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import imageCompression from "browser-image-compression";
import Swal from "sweetalert2";

function ImageCropperBanner({ show, imageFile, onSave, onClose }) {
  const cropperRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!imageFile) return;

    const reader = new FileReader();
    reader.onload = () => setImageSrc(reader.result);
    reader.readAsDataURL(imageFile);
  }, [imageFile]);

  const handleSave = async () => {
    if (!cropperRef.current?.cropper) return;

    try {
      setSaving(true);

      const canvas = cropperRef.current.cropper.getCroppedCanvas({
        width: 1920,
        height: 800,
      });

      const blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/webp", 0.9)
      );

      const compressedBlob = await imageCompression(blob, {
        maxSizeMB: 0.8,
        useWebWorker: true,
      });

      const finalFile = new File(
        [compressedBlob],
        `banner-${Date.now()}.webp`,
        { type: "image/webp" }
      );

      onSave(finalFile);
      onClose();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo procesar la imagen", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Recortar banner</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {imageSrc ? (
          <Cropper
            ref={cropperRef}
            src={imageSrc}
            style={{ height: 420, width: "100%" }}
            aspectRatio={4 / 5}          // 🔥 Prioridad mobile
            viewMode={1}
            guides
            responsive
            background={false}
            autoCropArea={1}
            movable
            zoomable
            scalable
            checkOrientation={false}
          />
        ) : (
          <div className="text-center py-4">Cargando imagen…</div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="dark" onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleSave} disabled={saving}>
          {saving ? <Spinner size="sm" /> : "Usar imagen"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ImageCropperBanner;
